import {html, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import componentStyles from './doctors-and-providers.css.lit.ts';
import {OutlineElement} from '../../base/outline-element/outline-element.ts';

export default class DoctorsAndProviders extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      searchString: {type: String},
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.getProvidersCount();
  }

  constructor() {
    super();
    this.content = html`
          Doctors &amp; <br/> Providers (loading...)
        `;
    this.providersCount = 0;
    this.searchString = false;
  }

  getProvidersCount() {
    fetch('/hf-api/getProvidersCount?search=' + this.searchString, {
      method: 'post'
    })
      .then((response) => response.json())
      .then((data) => {
        this.providersCount = data.providersCount
        this.content = html`
          Doctors &amp; <br/> Providers (${this.providersCount})
        `;
        this.requestUpdate()
      });
  }

  render() {
    return html`
      <hf-button
        ignoreExternalUrl
        target="_blank"
        href="https://providers.hf.org/search?unified=${this.searchString}"
        type="search-external"
        icon="external-link">
          ${this.content}
      </hf-button>
    `;
  }
}

customElements.define('hf-doctors-and-providers', DoctorsAndProviders);
